export { default } from "./useGetUserLicenses";
